import modalContainerSlice from "@components/ModalContainer/store/modalContainerSlice";
import fileSlice from "@components/SocialPersonal/store/fileSlice";
import authSlice from "@pages/Auth/store/authSlice";
import { headerSlice } from "../../../Header/store/headerSlice";
import languagesSlice from "@pages/LanguageTranslations/Languages/store/languagesSlice";
import themeSlice from "./themeSlice";

export const coreReducer = {
    modalContainer: modalContainerSlice.reducer,
    file: fileSlice.reducer,
    auth: authSlice.reducer,
    header: headerSlice.reducer,
    languages: languagesSlice.reducer,
    theme: themeSlice.reducer,
};
